if (!customElements.get("m-announcement-bar")) {
  class MAnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.sliderInitialized = false;
    }

    connectedCallback() {
      const enableSlider = this.dataset.enableSlider === "true";
      if (!enableSlider) return;

      // ✅ Wait until everything is fully loaded
      window.addEventListener("load", () => {
        this.initSlider();
      });
    }

    initSlider() {
      if (this.sliderInitialized) return;

      const autoplay = this.dataset.enableAutoplay === "true";
      const autoplaySpeed = parseInt(this.dataset.autoplaySpeed || "5", 10);
      const slideContainer = this.querySelector(".swiper-container");

      if (!slideContainer) return;

      // Destroy old instance if exists
      if (this.slider && typeof this.slider.destroy === "function") {
        this.slider.destroy(true, true);
      }

      // ✅ Count real slides only
      const slides = slideContainer.querySelectorAll(".swiper-slide");
      const shouldLoop = slides.length > 1;

      this.slider = new MinimogLibs.Swiper(slideContainer, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        autoplay: autoplay ? { delay: autoplaySpeed * 1000 } : false,
        loop: shouldLoop,
        navigation: {
          nextEl: this.querySelector(".swiper-button-next"),
          prevEl: this.querySelector(".swiper-button-prev"),
        },
      });

      this.sliderInitialized = true;
    }
  }

  customElements.define("m-announcement-bar", MAnnouncementBar);
}
